import {name as appName} from "../package.json";
import {AppController} from "./components/app";
import {
	AreaAssignController,
	AreaBoundaryController,
	AreaController,
	AreaEditController,
	AreaOverlapController
} from "./components/area";
import {breadcrumbsDirective} from "./components/breadcrumbs";
import {CustomBoundaryController, CustomController, CustomEditController} from "./components/custom";
import {DataConst, DataService} from "./components/data";
import {DistrictController} from "./components/district";
import {headerDirective} from "./components/header";
import {iconDirective, iconTextDirective} from "./components/icon";
import {infoDirective} from "./components/info";
import {mapDirective, MapDrawService, MapService} from "./components/map";
import {mapBoundariesDirective} from "./components/map-boundaries";
import {mapLabelsDirective} from "./components/map-labels";
import {mapOptionDirective} from "./components/map-option";
import {MissionController} from "./components/mission";
import {notificationDirective, NotificationService} from "./components/notification";
import {orgLinkFilter, OrgService, orgTranslateFilter} from "./components/org";
import {pageDirective} from "./components/page";
import {searchDirective, SearchService} from "./components/search";
import {boundaryStatusFilter, boundaryStatusFlaggedFilter, statusDirective} from "./components/status";
import {$exceptionHandler, UtilsService} from "./components/support";
import {TitleService} from "./components/title";
import {toggleDirective} from "./components/toggle";
import {toggleListDirective} from "./components/toggle-list";
import {triToggleDirective} from "./components/tri-toggle";
import {UserService} from "./components/user";
import {ZoneController} from "./components/zone";

angular.module(appName, ["ui.router", "ngAnimate", "ngSanitize", "pascalprecht.translate", "angular-bind-html-compile", "mos.frame", "imos", "imos.spinner", "imos.button", "imos.leave-page-prompt", "imos.radio", "imos.tri-toggle", "imos.tooltip", "imos.warn", "imos.item-wrapper", "imos.version-check"])

	.config(($stateProvider, $urlRouterProvider, $translateProvider, $translatePartialLoaderProvider, imosVersionCheckServiceProvider, env) => {
		"ngInject";

		$translateProvider.useSanitizeValueStrategy(null);
		$translatePartialLoaderProvider.addPart("PROS_MAPS");
        imosVersionCheckServiceProvider.cachedVersion = env ? { version: env.appVersion } : '';
		imosVersionCheckServiceProvider.htmlTemplateUrlShownWhenInErrorState = "components/imos-directive-library/imos-version-check-include/imos-version-check-include.html";

		/*BEGIN ROUTES*/
		$stateProvider
			.state("app", {
				abstract: true,
				url: "/:missionId",
				controller: "AppController",
				controllerAs: "vm",
				templateUrl: "./components/app/app-template.html"
			})
			.state("mission", {
				url: "",
				controller: "MissionController",
				controllerAs: "vm",
				templateUrl: "./components/mission/mission-template.html",
				parent: "app"
			})
			.state("zone", {
				url: "/zones/{zoneId:int}",
				controller: "ZoneController",
				controllerAs: "vm",
				templateUrl: "./components/zone/zone-template.html",
				parent: "app"
			})
			.state("district", {
				url: "/districts/{districtId:int}",
				controller: "DistrictController",
				controllerAs: "vm",
				templateUrl: "./components/district/district-template.html",
				parent: "app"
			})

			.state("area", {
				url: "/areas/{areaId:int}",
				controller: "AreaController",
				controllerAs: "vm",
				templateUrl: "./components/area/area-template.html",
				parent: "app"
			})
			.state("area-edit", {
				url: "/areas/{areaId:int}/edit",
				controller: "AreaEditController",
				controllerAs: "vm",
				templateUrl: "./components/area/area-edit-template.html",
				parent: "app"
			})
			.state("area-boundary", {
				url: "/areas/{areaId:int}/boundary",
				controller: "AreaBoundaryController",
				controllerAs: "vm",
				templateUrl: "./components/area/area-boundary-template.html",
				parent: "app"
			})
			.state("area-overlap", {
				url: "/areas/{areaId:int}/overlap",
				controller: "AreaOverlapController",
				controllerAs: "vm",
				templateUrl: "./components/area/area-overlap-template.html",
				parent: "app"
			})
			.state("area-assign", {
				url: "/areas/{areaId:int}/assign",
				controller: "AreaAssignController",
				controllerAs: "vm",
				templateUrl: "./components/area/area-assign-template.html",
				parent: "app"
			})

            .state("custom-create", {
                url: "/custom/create",
                controller: "CustomBoundaryController",
                templateUrl: "./components/custom/custom-boundary-template.html",
                controllerAs: "vm",
                parent: "app"
            })
			.state("custom", {
				url: "/custom/{customId}",
				controller: "CustomController",
				templateUrl: "./components/custom/custom-template.html",
				controllerAs: "vm",
				parent: "app"
			})
			.state("custom-edit", {
				url: "/custom/{customId}/edit",
				controller: "CustomEditController",
				templateUrl: "./components/custom/custom-edit-template.html",
				controllerAs: "vm",
				parent: "app"
			})
			.state("custom-boundary", {
				url: "/custom/{customId}/boundary",
				controller: "CustomBoundaryController",
				templateUrl: "./components/custom/custom-boundary-template.html",
				controllerAs: "vm",
				parent: "app"
			})
		;

		$urlRouterProvider
			.otherwise("/");
	})

	.constant("env", (window && window.__APP_ENV_VARS__) || {})
	.constant("DataConst", DataConst)

	.run(($rootScope, $translate, $timeout, MapService, imosVersionCheckService) => {
		"ngInject";

		if (!$translate.proposedLanguage()) {
			$translate.use("eng");
		}

		$timeout($rootScope.$broadcast('setHelpLink', { helpId: 1007 }), 100);

        //Version Check Stuff
        imosVersionCheckService.startVersionCheck();
	})

	.controller("AppController", AppController)
	.controller("MissionController", MissionController)
	.controller("ZoneController", ZoneController)
	.controller("DistrictController", DistrictController)
	.controller("AreaController", AreaController)
	.controller("AreaEditController", AreaEditController)
	.controller("AreaBoundaryController", AreaBoundaryController)
	.controller("AreaOverlapController", AreaOverlapController)
	.controller("AreaAssignController", AreaAssignController)
	.controller("CustomController", CustomController)
	.controller("CustomEditController", CustomEditController)
	.controller("CustomBoundaryController", CustomBoundaryController)
	.directive("pmIcon", iconDirective)
	.directive("pmIconText", iconTextDirective)
	.directive("pmInfo", infoDirective)
	.directive("pmMap", mapDirective)
	.directive("pmMapOption", mapOptionDirective)
	.directive("pmMapLabels", mapLabelsDirective)
	.directive("pmMapBoundaries", mapBoundariesDirective)
	.directive("pmPage", pageDirective)
	.directive("pmBreadcrumbs", breadcrumbsDirective)
	.directive("pmSearch", searchDirective)
	.directive("pmHeader", headerDirective)
	.directive("pmStatus", statusDirective)
	.directive("pmTriToggle", triToggleDirective)
	.directive("pmToggle", toggleDirective)
	.directive("pmToggleList", toggleListDirective)
	.directive("pmNotification", notificationDirective)
	.filter("boundaryStatus", boundaryStatusFilter)
	.filter("statusFlagged", boundaryStatusFlaggedFilter)
	.filter("orgLink", orgLinkFilter)
	.filter("orgTranslate", orgTranslateFilter)
	.factory("DataService", DataService)
	.factory("UserService", UserService)
	.factory("OrgService", OrgService)
	.factory("MapService", MapService)
	.factory("MapDrawService", MapDrawService)
	.factory("SearchService", SearchService)
	.factory("NotificationService", NotificationService)
	.factory("TitleService", TitleService)
	.factory("utils", UtilsService)
	.factory("$exceptionHandler", $exceptionHandler)

	.factory("$win", function ($window) {
		return angular.element($window);
	})
	.factory("google", function ($window) {
		$window.google = $window.google || {};
		return $window.google;
	})
;
